$.fn.AtelierToolbar = function() {
	let self = this
	self.links = self.find('a:not(.atelier-toolbar__mobile-logo)')
	self.scroller = self.closest('.scroller')

	self.initialize_menu = function() {
		self.links.each(function() {
			$(this).data('preventTransition', 1).on('click', function() {
        if ($(this).attr('href') == '#footer-contact') {
          let targetTop = self.scroller.get(0).scrollHeight - $(window).height()
  				self.scroller.scrollTo(targetTop, 350, 5, 'easeInOutQuart')
          if (!$.mlmi.mobile.isMobile) {
            $('.footer').addClass('footer--will-appear')
            setTimeout(function() {
              $('.footer').css('transform', 'translateY(-' + ($('.footer').outerHeight(false) - 20) + 'px)')
              setTimeout(function() {
                $('.footer').removeClass('footer--will-appear')
              }, 250)
            }, (targetTop / 5))
          }
        } else {
          let targetTop = $($(this).attr('href')).offset().top - 40
          if (targetTop + $(window).height() > self.scroller.get(0).scrollHeight) {
            targetTop = self.scroller.get(0).scrollHeight - $(window).height()
          }
          if ($.mlmi.mobile.isMobile) {
            targetTop -= parseInt(self.closest('.panel__content-card').css('margin-top'), 10)
            targetTop += 24
          }
  				self.scroller.scrollTo(targetTop, 350, 5, 'easeInOutQuart')
        }
				return false
			})
		})
		self.links
	}

  self.initialize_mobile = function() {
    self.find('.atelier-toolbar__title').on('click', function() {
      if ($.mlmi.mobile.matchesMedia()) {
        self.find('.atelier-toolbar__menu').slideToggle(175)
      }
    })
  }

	return function() {
    self.initialize_mobile()
	  self.initialize_menu()
	  return self
	}()
}
